import React from 'react'
import styled from 'styled-components'

import Logo from 'components/Svg/logo.component.svg'

const PlusButton = ({ text, onClick }) => (
  <Wrapper onClick={() => onClick()}>
    <Logo />
    <Span>{text}</Span>
  </Wrapper>
)

export default PlusButton

const Wrapper = styled.button`
  margin: 0 auto;
  display: block;
  border: 0;
  background: none;
  margin-top: 30px;
  max-width: 85px;
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    transform: scale(1.04535);
  }
`

const Span = styled.span`
  color: #3e3e3e;
  font-size: 12px;
  line-height: 16px;
  font-weight: bold;
  text-align: center;
  display: block;
  margin: 10px 0;
  text-transform: uppercase;
`



// WEBPACK FOOTER //
// ./src/components/PlusButton/index.js